import { ASTNode } from '../scriptcompiler/AstNode'
import { CalcRuntimeError } from './RuntimeTypes'

export const evaluatorErrorWithNode = (message: string, node: ASTNode): CalcRuntimeError => ({
	area: 'CompiledCalcScriptEvaluator',
	message,
	line: node.line,
	column: node.column,
})
